/**
 * Safely get a nested property from an object using a dot-notation path
 */
export const getProperty = (obj: any, path: string): any => {
  const keys = path.split('.');
  let result = obj;

  for (const key of keys) {
    if (result == null || typeof result !== 'object') {
      return undefined;
    }
    result = result[key];
  }

  return result;
};

/**
 * Safely set a nested property on an object using a dot-notation path
 */
export const setProperty = (obj: any, path: string, value: any): any => {
  const keys = path.split('.');
  const lastKey = keys.pop()!;
  let current = obj;

  for (const key of keys) {
    if (!(key in current)) {
      current[key] = {};
    }
    current = current[key];
  }

  current[lastKey] = value;
  return obj;
};

/**
 * Sets a value in an object at a given path.
 * The path can be a dot-separated string like 'a.b.c' or an array of keys ['a', 'b', 'c'].
 * 
 * @param obj The object to modify
 * @param path The path to the property to set
 * @param value The value to set
 */
export const set = (obj: any, path: string, value: any): void => {
  const keys = path.split('.');
  let current = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (!(key in current)) {
      current[key] = {};
    }
    current = current[key];
  }

  current[keys[keys.length - 1]] = value;
}; 